import React from 'react'
import DataView from 'EurestoComponents/DataForm'
import Constants from 'EurestoFonction/Constants'

export const Critere = () => (
    <DataView module={Constants.module.CRM} object={Constants.donnee.info_tiers}/>
)

export default Critere



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/CRM/Critere/index.js